import type { WorkspaceUserDto } from '../../types/workspace.types';

import WorkspaceUserRow from './WorkspaceUserRow';

interface Props {
  users: WorkspaceUserDto[];
  currentUserId?: string;
  onEditRole?: (user: WorkspaceUserDto) => void;
  onRemoveUser?: (user: WorkspaceUserDto) => void;
}

const WorkspaceUserList: React.FC<Props> = ({
  users,
  currentUserId,
  onEditRole,
  onRemoveUser,
}) => (
  <table className="min-w-full divide-y divide-gray-100">
    <thead className="bg-gray-50/70">
      <tr>
        <th className="py-3.5 px-6 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider whitespace-nowrap">
          Full Name
        </th>
        <th className="py-3.5 px-6 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider whitespace-nowrap">
          Email
        </th>
        <th className="py-3.5 px-6 text-left text-xs font-semibold text-gray-400 uppercase tracking-wider whitespace-nowrap">
          Application Role
        </th>
        {(onEditRole || onRemoveUser) && (
          <th className="py-3.5 px-6 text-right text-xs font-semibold text-gray-400 uppercase tracking-wider whitespace-nowrap">
            Actions
          </th>
        )}
      </tr>
    </thead>
    <tbody className="bg-white divide-y divide-gray-100">
      {users.map((user) => (
        <WorkspaceUserRow
          key={user.userId}
          user={user}
          currentUserId={currentUserId}
          onEditRole={onEditRole}
          onRemoveUser={onRemoveUser}
        />
      ))}
    </tbody>
  </table>
);

export default WorkspaceUserList;
